require.register("app/restaurant/stat/ProductCARankView", function(exports, require, module){
  $0
  
});

